import "./footer.css";

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="bttm-txt">
        <p>Personal website & portfolio by Gabriel Anguiano.</p>
        <p className="p-txt">Built with ReactJS & hosted with Netlify.</p>
        <p className="copyright">© 2023 Gabriel Anguiano. All rights reserved.</p>
      </div>
    </footer>
  )
}

export default Footer